export class WordState {
  constructor() {
    this.unplacedWords = [];
    this.failedDirections = new Map();
  }

  addUnplaced(word) {
    if (!this.unplacedWords.includes(word)) {
      this.unplacedWords.push(word);
    }
  }

  removeUnplaced(word) {
    this.unplacedWords = this.unplacedWords.filter(w => w !== word);
  }

  registerFailure(word, direction) {
    if (!this.failedDirections.has(word)) {
      this.failedDirections.set(word, new Set());
    }
    this.failedDirections.get(word).add(direction);
  }

  clearFailures(word) {
    this.failedDirections.delete(word);
  }
}
